import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import IconEdit from '../../../assets/images/icon-edit.png'
import Select, { components, ContainerProps } from 'react-select'
import { useHistory } from "react-router"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import styled from "styled-components"
import PriceUtils from "../../../helpers/PriceUtils"
import NumberFormat from 'react-number-format';
import TextUtils from "../../../helpers/TextUtils"
import Loader from "../../../components/Loader"
import IconRight from '../../../assets/images/ic_right-gray.svg';
import IconPayment from '../../../assets/images/ic_paymenttype.svg';
import { cloneDeep } from "lodash"
import { toast } from "react-toastify"
import RowEmpty from "../../../components/RowEmpty"
import { baseUrl, payment_method } from "../../../constants/environment"
import APIClient from "../../../helpers/APIClient";
import ReactTooltip from "react-tooltip";

const PaymentMethodList = [
    {
        value: 'cash',
        label: "Tiền mặt"
    },
    {
        value: 'transfer',
        label: "Chuyển khoản"
    },
    {
        value: 'visa',
        label: "Visa"
    },
]

export function CustomOptionOrderPackage({ innerProps, data }: any) {
    const Label_card_packs: any = (value: any) => {
        if (value == 'membership_card') {
            return 'Gói thẻ thành viên'
        }
        if (value == 'account_card') {
            return 'Gói thẻ tài khoản'
        }
        if (value == 'stage') {
            return 'Dịch vụ theo giai đoạn phát triển của trẻ'
        }
        if (value == 'course') {
            return 'Khoá học dinh dưỡng'
        }
    }

    function convertToDisplayName(type: any) {
        switch (type) {
            case 'nhi':
                return 'Nhi';
            case 'dinh_duong':
                return 'Dinh Dưỡng';
            default:
                return type;
        }
    }

    const formatExam_type = data?.examination_type?.map((type: any) => convertToDisplayName(type));

    return (
        <div {...innerProps} style={{ display: 'flex', justifyContent: 'space-between', padding: "10px", borderBottom: "solid 1px #DCDCDC", cursor: 'pointer' }}>
            <div style={{ width: '60%' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{data?.code} - {data?.servicepackage_id?.name}</div>
                <div>Loại gói thẻ: {Label_card_packs(data?.type)}</div>
                <div>Chiết khấu dịch vụ: <span style={{ color: '#48A800' }}>{data?.discount_service_examination}%</span></div>
                <div>Loại khám: {formatExam_type?.join('/')}</div>
                {
                    data?.type == 'membership_card' ? (
                        <div>Hạng thành viên: {data?.customer_rank_config_line_id?.rank_name}</div>
                    ) : null
                }
            </div>
            <div style={{ width: '40%', textAlign: 'end' }}>
                <div>
                    <a className='textDecoration' href={`/servicepack/${data?.service_package_id || data?.servicepackage_id?.id}/view`} style={{ color: 'blue', fontStyle: 'italic', textDecorationColor: 'lightblue' }} target="_blank">Xem chi tiết</a>
                </div>
                <div>Khả dụng{data?.type !== 'account_card' ? <span>(khám)</span> : null}: <span style={{ color: '#48A800' }}>{data?.type == 'account_card' ? PriceUtils.format((Number(data?.total_group) - Number(data?.total_group_used)), 'đ') : ((data?.count_examination || 0) - (data?.used_examination || 0))}{data?.type !== 'account_card' ? ' lần' : null}</span></div>
                <div>Chiết khấu đơn hàng: <span style={{ color: '#48A800' }}>{data?.discount_order}%</span></div>
                <div>Hạn sử dụng: {data?.expiry_time == null ? 'Không thời hạn' : (moment(data?.expiry_time).format('DD/MM/YYYY') == 'Invalid date' ? null : moment(data?.expiry_time).format('DD/MM/YYYY'))}</div>
            </div>
        </div>
    );
}

const OrderAddInfo = (props: any) => {
    const { data, setData, type, onlyView, orderSource, product, payment } = props
    const router = useHistory()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [orderpackage, setOrderpackage] = useState<any>();
    const [paymentHistory, setPaymentHistory] = useState<any>(props?.payment);

    useEffect(() => {
        if (data?.total_package_used && Number(data?.total_package_used) > 0 && type == 'view') {
            setPaymentHistory([
                ...props?.payment,
                {
                    created_time: data?.updated_time == null ? data?.created_time : data?.updated_time,
                    payment_method: {
                        name: 'Gói thẻ tài khoản'
                    },
                    payment_total: data?.total_package_used,
                    type: "account_card"
                }
            ]);
        } else {
            setPaymentHistory(props?.payment)
        }
    }, [props?.payment])

    useEffect(() => {
        loadInit()
    }, [])
    const idCustomer = data?.customer_id?.id;
    useEffect(() => {
        if (idCustomer !== undefined) {
            fetchCustomerOrderpackage(idCustomer);
        }
    }, [idCustomer]);

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        }
        const [
            responsePaymentMethod
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
                include_vnpay: true
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr: any = [];
            responsePaymentMethod.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (value?.length > 1000) return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
            setData({
                ...data,
                customer_id: {
                    ...data?.customer_id,
                    phone: value
                }
            })
        }
        else {
            setData({
                ...data,
                [name]: value
            })
        }

    }

    const getLabelMethod = () => {
        const labelArr: any = [];
        const labellabel: any = [];
        payment?.map((item: any) => {
            if (!labelArr?.includes(item?.payment_method_id?.id || item?.payment_method_id)) {
                labelArr?.push(item?.payment_method_id?.id || item?.payment_method_id)
                paymentMethod?.map((itemLabel: any) => {
                    if ((item?.payment_method_id?.id == itemLabel?.value || item?.payment_method_id == itemLabel?.value)) {
                        labellabel?.push(itemLabel?.label)
                    }
                })
            }
        })
        if (labellabel?.length > 0) {
            return labellabel?.join(", ")
        }
        else return "Chưa chọn hình thức thanh toán"
    }

    const calTotal = () => {
        let total: any = {
            count: 0,
            total: 0,
            discount: 0,
            discount_service: 0
        }
        total = product?.reduce((prev: any, item: any) => {
            const totalItem = Number(item?.price || 0)
            const discount = item?.discount_type === 'price' ? Number(item?.discount_value || 0) :
                totalItem * Number(item?.discount_value || 0) / 100
            const discount_service = data?.orderspackage?.product_type?.map((value: any) => {
                if (value === item?.product?.product_type) {
                    if (Number(data?.orderspackage?.discount_order) > 0) {
                        return (totalItem - discount) * Number(data?.orderspackage?.discount_order) / 100
                    } else {
                        return 0
                    }
                } else {
                    return 0
                }
            })
            const total_discount_service = discount_service?.reduce((prev: any, item: any) => {
                return prev + item
            }, 0)
            prev.discount_service += total_discount_service * Number(item?.quantity || 0)
            prev.total += totalItem * Number(item?.quantity || 0)
            prev.discount += discount * Number(item?.quantity || 0)

            prev.count += Number(item?.quantity || 0)
            return prev
        }, total)
        const sub_total = Number(total?.total || 0) - Number(total?.discount || 0)
        const discount = data?.discount_type === 'price' ? Number(data?.discount_value || 0) :
            sub_total * Number(data?.discount_value || 0) / 100;
        const shipping_fee = Number(data?.shipping_fee || 0)
        const sub_total_end = Number(sub_total || 0) - Number(discount || 0) + shipping_fee - (total?.discount_service || 0)
        total.sub_total = sub_total
        total.sub_total_end = sub_total_end
        return total
    }

    const calTotalPayment = () => {
        const totalPayment = payment?.reduce((prev: any, item: any) => {
            if (item?.payment_total) prev = prev + Number(item?.payment_total)
            return prev
        }, 0)
        return Math.floor(totalPayment || 0)
    }

    const total = calTotal()

    const fetchCustomerOrderpackage = async (id: number) => {
        const url = `${baseUrl}/customer/orderpackage/${id}`;
        const response: any = await APIClient.GET(url, { use_status: 'active' });
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            let Arr: any = [];
            const today = new Date();
            response.response?.data?.forEach((e: any) => {
                e?.orderspackage_services?.forEach((a: any) => {
                    if (a?.type == 'course' && a?.count_examination == null) return
                    const activeTimeConfig = new Date(a?.active_time_config);
                    // Kiểm tra active_time_config đã qua hoặc là ngày hôm nay
                    if (activeTimeConfig <= today && a?.reserve_time == null) {
                        Arr?.push({
                            orderspackage_id: e?.id,
                            service_package_id: a?.servicepackage_id?.id,
                            value: a?.servicepackage_id?.id,
                            label: a?.servicepackage_id?.name,
                            ...a,
                            code: e?.code
                        });
                    }
                })
            })
            if (data?.service_package_id?.id) {
                const existingItem = Arr?.find((item: any) => item?.value == data?.orderspackage_id?.orderspackage_services?.[0]?.id);
                // Kiểm tra nếu value không tồn tại và ngày active_time_config đã qua hoặc là ngày hôm nay
                if (!existingItem && new Date(data?.orderspackage_id?.active_time_config) <= today) {
                    Arr.push({
                        orderspackage_id: data?.orderspackage_id?.id,
                        service_package_id: data?.service_package_id?.id,
                        value: data?.service_package_id?.id,
                        label: data?.service_package_id?.name,
                        ...data?.service_package_id,
                        servicepackage_id: data?.service_package_id,
                        code: data?.service_package_id?.code,
                        servicepackage_total: data?.orderspackage_id?.servicepackage_total || 0
                    })
                }
            }
            setOrderpackage(Arr);
        }
    }

    function CustomOption({ innerProps, data }: any) {
        const Label_card_packs: any = (value: any) => {
            if (value == 'membership_card') {
                return 'Gói thẻ thành viên'
            }
            if (value == 'account_card') {
                return 'Gói thẻ tài khoản'
            }
            if (value == 'stage') {
                return 'Dịch vụ theo giai đoạn phát triển của trẻ'
            }
            if (value == 'course') {
                return 'Khoá học dinh dưỡng'
            }
        }

        function convertToDisplayName(type: any) {
            switch (type) {
                case 'nhi':
                    return 'Nhi';
                case 'dinh_duong':
                    return 'Dinh Dưỡng';
                default:
                    return type;
            }
        }

        const formatExam_type = data?.examination_type.map((type: any) => convertToDisplayName(type));

        return (
            <div {...innerProps} style={{ display: 'flex', justifyContent: 'space-between', padding: "10px", borderBottom: "solid 1px #DCDCDC", cursor: 'pointer' }}>
                <div style={{ width: '60%' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{data?.code} - {data?.servicepackage_id?.name}</div>
                    <div>Loại gói thẻ: {Label_card_packs(data?.type)}</div>
                    <div>Chiết khấu dịch vụ: <span style={{ color: '#48A800' }}>{data?.discount_service_examination}%</span></div>
                    <div>Loại khám: {formatExam_type.join('/')}</div>
                    {
                        data?.type == 'membership_card' ? (
                            <div>Hạng thành viên: {data?.customer_rank_config_line_id?.rank_name}</div>
                        ) : null
                    }
                </div>
                <div style={{ width: '40%', textAlign: 'end' }}>
                    <div>
                        <a className='textDecoration' href={`/servicepack/${data?.service_package_id}/view`} style={{ color: 'blue', fontStyle: 'italic', textDecorationColor: 'lightblue' }} target="_blank">Xem chi tiết</a>
                    </div>
                    <div>Khả dụng{data?.type !== 'account_card' ? <span>(khám)</span> : null}: <span style={{ color: '#48A800' }}>{data?.type == 'account_card' ? PriceUtils.format((Number(data?.total_group) - Number(data?.total_group_used)), 'đ') : (data?.count_examination || 0)}{data?.type !== 'account_card' ? ' lần' : null}</span></div>
                    <div>Chiết khấu đơn hàng: <span style={{ color: '#48A800' }}>{data?.discount_order}%</span></div>
                    <div>Hạn sử dụng: {data?.expiry_time == null ? 'Không thời hạn' : (moment(data?.expiry_time).format('DD/MM/YYYY') == 'Invalid date' ? null : moment(data?.expiry_time).format('DD/MM/YYYY'))}</div>
                </div>
            </div>
        );
    }

    const customStyles: any = {
        option: (provided: any, state: any) => ({
            ...provided,
            display: 'flex',
            justifyContent: 'space-between',
            width: '1300px'
        }),
    };

    const labelObject = (value: any) => {
        if (value == 'medicine') {
            return 'Thuốc'
        }
        if (value == 'functional_foods') {
            return 'Thực phẩm chức năng'
        }
    }

    const SelectContainer = ({
        children,
        ...props
    }: any) => {
        return (
            <>
                <div data-tip data-for="tooltipId">
                    <components.SelectContainer {...props}>
                        {children}
                    </components.SelectContainer>
                </div>
            </>
        );
    };

    const totalDiscountC = () => {
        let total_discount: any = {
            // chiết khấu gói C
            // số tiền trừ gói C
            // số tiền khách cần trả
            // số tiền khách cần trả trong trường hợp gói C bằng 0
            discountC: 0,
            discountCardC: 0,
            total_customer: 0,
        }
        if (product?.length > 0) {
            total_discount = product.reduce((prev: any, item: any) => {
                prev.discountC += item?.discountC || 0;
                prev.discountCardC += item?.priceDiscountC || 0;
                return prev;
            }, total_discount);
        }
        // phí ship
        const shipping_fee = Number(data?.shipping_fee || 0)
        // giảm giá trên tổng đơn
        const discount = data?.discount_type === 'price' ? Number(data?.discount_value || 0) :
            total.sub_total * Number(data?.discount_value || 0) / 100;
        let total_customer = 0;
        let discountCardC = Number(total_discount?.discountCardC || 0) - (Number(discount) || 0) + (Number(shipping_fee) || 0);
        if (Number(discountCardC || 0) <= (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))) {
            // total_customer = Number(data?.orderspackage?.total_group || 0) - Number(total_discount.discountCardC || 0) - (Number(discount) || 0) + (Number(shipping_fee) || 0)
            total_customer = 0
        } else {
            if (type == 'view') {
                total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used))
            } else {
                // if(data?.id) {
                //     // case chỉnh sửa
                //     total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))
                // }else {
                // case add
                total_customer = Number(discountCardC || 0) - (Number(data?.orderspackage?.total_group || 0) - Number(data?.orderspackage?.total_group_used || 0) + Number(data?.total_package_used || 0))
                // }

            }
        }
        total_discount.total_customer = total_customer
        total_discount.discountCardC = discountCardC
        return total_discount;
    }

    const total_discount = totalDiscountC();

    const customer_to_pay = () => {
        if (data?.orderspackage?.type == 'account_card' && type == 'view') {
            if (Number(data?.total_group_package || 0) > Number(data?.total_package_used)) {
                return (
                    PriceUtils.format(0)
                )
            } else {
                return PriceUtils.format(Number(total_discount?.total_customer || 0))
            }
        }
        if (data?.orderspackage?.type == 'account_card' && type !== 'view') {
            return (
                PriceUtils.format(Number(total_discount.total_customer || 0))
            )
        }
        if (data?.orderspackage?.type !== 'account_card') {
            return (
                PriceUtils.format(Number(total?.sub_total_end || 0))
            )
        }
    }

    return (
        <>
            <PageBody>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="nutri-title mb-3">Giá trị đơn hàng</div>
                    {type === 'view' && <b className="text-success cursor-pointer" onClick={() => setIsOpen(!modalIsOpen)}>Lịch sử thanh toán</b>}
                </div>
                <Row>
                    <Col md={12} xs={12}>
                        <div className='order-total-row mb-2'>
                            <ValueTextLabel>Tổng tiền hàng <span className="ml-2 total-label">{PriceUtils.format(total?.count || 0, '')}</span></ValueTextLabel>
                            <ValueTextLabel>{PriceUtils.format(total?.total || 0)}</ValueTextLabel>
                        </div>
                    </Col>
                    <Col md={12} xs={12}>
                        <div className='order-total-row mb-2'>
                            <ValueTextLabel>Gói thẻ dịch vụ áp dụng</ValueTextLabel>
                            {
                                onlyView ? (
                                    <div data-for="tooltipId" data-tip aria-haspopup="true" className='w_44'>
                                        <Select
                                            placeholder="Chọn"
                                            className="react-select mb-2 w_44 w-100"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView}
                                            options={orderpackage}
                                            onChange={(val: any) => {
                                                setData({
                                                    ...data,
                                                    orderspackage: val
                                                })
                                            }}
                                            value={orderpackage?.filter(
                                                (option: any) =>
                                                    data?.orderspackage?.value == option.value
                                            )}
                                            components={{
                                                Option: CustomOptionOrderPackage,
                                                Control: SelectContainer
                                            }}
                                            styles={customStyles}
                                        />
                                    </div>
                                ) : (
                                    <Select
                                        placeholder="Chọn"
                                        className="react-select mb-2 w_44 class_flex"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        options={orderpackage}
                                        onChange={(val: any) => {
                                            setData({
                                                ...data,
                                                orderspackage: val
                                            })
                                        }}
                                        value={orderpackage?.filter(
                                            (option: any) =>
                                                data?.orderspackage?.value == option.value
                                        )}
                                        components={{
                                            Option: CustomOption,
                                            Control: SelectContainer
                                        }}
                                        styles={{
                                            ...customStyles_servicePackage,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 475,
                                            }),
                                        }}
                                    >
                                    </Select>
                                )
                            }

                        </div>
                    </Col>
                    {(type !== 'view' && data?.customer_id && orderpackage?.length > 0 && (data?.orderspackage == '' || data?.orderspackage?.name == undefined)) && (
                        <Col md={12} xs={12}>
                            <span style={{ color: '#48A800' }}>Khách hàng này đã mua gói thẻ dịch vụ, vui lòng chọn 1 để áp dụng</span>
                        </Col>
                    )}
                    {(type !== 'view' && data?.customer_id && orderpackage?.length == 0 && (data?.orderspackage == '' || data?.orderspackage?.name == undefined)) && (
                        <Col md={12} xs={12}>
                            <span style={{ color: '#EDA119' }}>Khách hàng này chưa mua gói thẻ dịch vụ nào, không thể chọn để áp dụng</span>
                        </Col>
                    )}
                    <Col md={12} xs={12}>
                        <div className='order-total-row mb-2'>
                            <ValueTextLabel>Chiết khấu gói thẻ dịch vụ</ValueTextLabel>
                            <ValueTextTotal style={{ color: '#1C1D21' }}>{data?.orderspackage?.type == 'account_card' ? PriceUtils.format(total_discount.discountC) : PriceUtils.format(total?.discount_service || 0)}</ValueTextTotal>
                        </div>
                    </Col>
                    <Col md={12} xs={12}>
                        <div className='order-total-row mb-2'>
                            <ValueTextLabel>Giảm giá</ValueTextLabel>
                            <ValueTextLabel>
                                <div className='order-discount-group order-discount-group-left'>
                                    <Button style={{ opacity: 1 }} disabled={onlyView} onClick={() => handleChangeInput({ target: { name: 'discount_type', value: 'price' } })} className="react-select discount_type" color={data?.discount_type === 'price' ? 'success' : 'light'}>đ</Button>
                                    <Button style={{ opacity: 1 }} disabled={onlyView} onClick={() => handleChangeInput({ target: { name: 'discount_type', value: 'percent' } })} className="react-select discount_type" color={data?.discount_type === 'percent' ? 'success' : 'light'}>%</Button>
                                    <NumberFormat
                                        onChange={(e: any) => {
                                            let value = TextUtils.onlyNumber(e.target.value)
                                            handleChangeInput({ target: { name: 'discount_value', value: value } })
                                        }}
                                        name={'discount_value'} type={'text'} className="form-control discount_value"
                                        value={type === 'view' && !data?.discount_value ? '---' : data?.discount_value}
                                        disabled={onlyView}
                                        placeholder={(type == 'view' && !data?.discount_value) ? "---" : "Nhập giá trị..."} thousandSeparator={true}
                                    />
                                </div>
                            </ValueTextLabel>
                        </div>
                    </Col>
                    {
                        data?.orderspackage?.type == 'account_card' ? (
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Số tiền trừ gói thẻ</ValueTextLabel>
                                    <ValueTextTotal>{
                                        onlyView ? PriceUtils.format(data?.total_package_used || 0) :
                                            Number(total_discount.discountCardC) > (Number(data?.orderspackage?.total_group) - Number(data?.orderspackage?.total_group_used) + Number(data?.total_package_used || 0)) ?
                                                PriceUtils.format(
                                                    (Number(data?.orderspackage?.total_group) - Number(data?.orderspackage?.total_group_used) + Number(data?.total_package_used || 0))
                                                )
                                                : PriceUtils.format(
                                                    (Number(total_discount.discountCardC || 0))
                                                )
                                    }</ValueTextTotal>
                                </div>
                            </Col>
                        ) : null
                    }
                    <Col md={12} xs={12}>
                        <div className='order-total-row mb-2'>
                            <ValueTextLabel>Khách cần trả</ValueTextLabel>
                            <ValueTextTotal style={{ color: '#EDA119' }}>{
                                customer_to_pay()
                            }</ValueTextTotal>
                        </div>
                    </Col>
                    <Col md={12} xs={12} className="mb-2">
                        <div className='order-total-row'>
                            <ValueTextLabel>Khách thanh toán
                                <div style={{ cursor: 'pointer', marginLeft: 10 }} onClick={() => setIsOpen(!modalIsOpen)}>
                                    <img src={IconPayment} width={18} height={18} alt="" />
                                    <img src={IconRight} width={18} height={18} alt="" />
                                </div>
                            </ValueTextLabel>
                            <ValueTextValue>{PriceUtils.format(calTotalPayment())}</ValueTextValue>
                        </div>
                        <div className="type-payment">{getLabelMethod()}</div>
                    </Col>
                </Row>
            </PageBody>
            {
                data?.orderspackage?.label ? (
                    <ReactTooltip id="tooltipId" type="info">
                        {data?.orderspackage?.label ? `${data?.orderspackage?.label}` : 'Đang tải dữ liệu...'}
                    </ReactTooltip>
                ) : null
            }

            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {type === 'view' ?
                    <RenderActionModalHistory {...props} total={total} onlyView={onlyView} closeModal={() => setIsOpen(false)} data={data} paymentHistory={paymentHistory} /> :
                    <RenderActionModal {...props} total={total} onlyView={onlyView} closeModal={() => setIsOpen(false)} total_discount={total_discount} />
                }
            </ModalPopup>
        </>
    )
}

const RenderActionModalHistory = (props: any) => {
    const { closeModal, onlyView, data, paymentHistory } = props;
    const [loading, setLoading] = useState(false);
    const [payment, setPayment] = useState<any>(paymentHistory);

    const sortedData = payment.sort((a: any, b: any) => new Date(b?.created_time) - new Date(a?.created_time));

    const router = useHistory();

    return (
        <CardBody className='p-0' style={{ width: 600 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">Lịch sử thanh toán</h5>
                <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-0">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <div className="table-responsive" style={{ overflow: 'unset' }}>
                        <table className="mb-0 table-custom no-bg table table-input" >
                            <thead>
                                <tr>
                                    <th className='text-center' style={{ width: '25%' }}>Hình thức</th>
                                    <th className='text-center' style={{ width: '18%' }}>Số tiền</th>
                                    <th className='text-center' style={{ width: '18%' }}>Thời gian</th>
                                    <th className='text-center' style={{ width: '18%' }}>Chứng từ</th>
                                </tr>
                            </thead>
                            {sortedData?.length === 0 && <RowEmpty column={4} title="Lịch sử thanh toán trống!" />}
                            {sortedData?.length > 0 &&
                                <tbody>
                                    {sortedData?.map((item: any, index: any) => {
                                        return (
                                            <tr key={`payment-${index}`}>
                                                <td className='text-center'>{item?.payment_method?.name}</td>
                                                <td className='text-center'>{PriceUtils.format(item?.payment_total || 0)}</td>
                                                <td className='text-center'>{moment(item?.created_time).format('HH:ss DD/MM/YYYY')}</td>
                                                <td className='text-center'>---</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>}
                        </table>
                    </div>
                </PageContent>
            </div>
            {loading && <Loader />}
        </CardBody>
    )
}

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [payment, setPayment] = useState(props?.payment);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [vnpayTerminal, setVNPayTerminal] = useState<any>([]);
    const { closeModal, total, type, onlyView, data, branch_ids, total_discount } = props;
    const branchF = branch_ids ? branch_ids : props?.location?.state?.exam

    useEffect(() => {
        setPayment(props?.payment)
    }, [props?.payment])

    useEffect(() => {
        loadInit()
    }, [])

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        }
        const [
            responsePaymentMethod,
            responseVNPayTerminal,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
                include_vnpay: true
            }),
            APIClient.GET(`${baseUrl}/vnpay-terminal`, {
                ...params,
                branch_id: props?.user?.branch_id?.id,
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr: any = [];
            responsePaymentMethod.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
        if (responseVNPayTerminal.response?.data !== undefined) {
            let ListArr: any = [];
            responseVNPayTerminal.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setVNPayTerminal(ListArr)
        }
    }

    const handlePaymentAdd = () => {
        const newDetailtiveUser = {
            payment_id: "",
            quantity: "",
        };
        setPayment([...payment, newDetailtiveUser]);
    };

    const handlePaymentUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser[index] = dataDetail;
        setPayment(newDetailtiveUser);
    };

    const handlePaymentRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(payment);
        newDetailtiveUser.splice(index, 1);
        setPayment(newDetailtiveUser);
    };

    const calTotalPayment = () => {
        const totalPayment = payment?.reduce((prev: any, item: any) => {
            if (item?.payment_total) prev = prev + Number(item?.payment_total)
            return prev
        }, 0)
        return Math.floor(totalPayment || 0)
    }

    const handleSubmit = () => {
        let paymentCheckVnpay = false
        const paymentCheck = payment?.reduce((prev: any, item: any) => {
            const vnpay_payment = [payment_method.vnpay_qr_id, payment_method.vnpay_spos_id].includes(Number(item?.payment_method_id))
            if (vnpay_payment) paymentCheckVnpay = true
            if (
                (
                    (item?.payment_method_id && !item?.payment_total)
                    || (!item?.payment_method_id && item?.payment_total) || !item?.fundaccount_id
                )
                || (
                    vnpay_payment && (
                        !(item?.payment_method_id && item?.payment_total && item?.vnpay_terminal_id)
                    )
                )
            ) {
                prev = false
            }
            return prev
        }, true)
        if (!paymentCheck) {
            toast.warning(paymentCheckVnpay ? "Hình thức , tài khoản quỹ , máy POS hoặc số tiền không được để trống!" : 'Hình thức , tài khoản quỹ hoặc số tiền không được để trống!');
            return false
        }
        //kiểm tra xem tổng tiền thanh toán có vượt quá ko
        const totalPayment = calTotalPayment()
        let totalPaymentLeft = 0;
        if (data?.orderspackage?.type == 'account_card') {
            totalPaymentLeft = totalPayment - total_discount.total_customer
        } else {
            totalPaymentLeft = totalPayment - total?.sub_total_end
        }

        if (totalPaymentLeft > 0) {
            toast.warning('Số tiền thanh toán không thể vượt quá tổng tiền đơn hàng!');
            return false
        }
        const newpayment = payment?.reduce((prev: any, item: any) => {
            if (item?.payment_method_id && item?.payment_total) {
                prev = [...prev, item]
            }
            return prev

        }, [])
        props?.setPayment(newpayment);
        closeModal()
    };
    const totalPayment = calTotalPayment()

    let totalPaymentLeft = 0
    if (data?.orderspackage?.type == 'account_card') {
        totalPaymentLeft = totalPayment - total_discount.total_customer
    } else {
        totalPaymentLeft = totalPayment - total?.sub_total_end
    }

    return (
        <CardBody className='p-0' style={{ width: 680 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">Thanh toán</h5>
                <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2 pr-4 pl-4">
                <Row>
                    <Col md={12} xs={12}>
                        <div className='order-total-row'>
                            <ValueTextLabel>Tổng tiền cần thanh toán</ValueTextLabel>
                            <ValueTextTotal style={{ color: '#EDA119' }}>{
                                data?.orderspackage?.type == 'account_card' ? PriceUtils.format(total_discount.total_customer || 0)
                                    : PriceUtils.format(total?.sub_total_end || 0)
                            }</ValueTextTotal>
                        </div>
                    </Col>
                    <Col md={12} xs={12}>
                        <div className='order-total-row'>
                            <ValueTextLabel>Đã thanh toán</ValueTextLabel>
                            <ValueTextLabel>{PriceUtils.format(totalPayment || 0)}</ValueTextLabel>
                        </div>
                    </Col>
                    <Col md={12} xs={12}>
                        <div className='order-total-row'>
                            <ValueTextLabel>{totalPaymentLeft > 0 ? 'Tiền thừa trả khách' : 'Tiền thiếu'}</ValueTextLabel>
                            <ValueTextLabel>{PriceUtils.format(totalPaymentLeft > 0 ? totalPaymentLeft : -totalPaymentLeft || 0)}</ValueTextLabel>
                        </div>
                    </Col>
                </Row>
                <div className='order-total-row'>
                    <ValueTextLabel>Thông tin thanh toán</ValueTextLabel>
                </div>
                <div className="mb-3">
                    {
                        type != 'view' && payment?.length === 0 ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={handlePaymentAdd} color='success'><i className='uil-plus'></i> Thêm phương thức thanh toán</Button>
                            </div>
                            : payment?.map((item: any, index: number) => (
                                <PaymentItem
                                    branch_id={branchF ? branchF : props?.user?.branch_id?.id}
                                    detailIndex={index}
                                    data={item}
                                    onChangeData={(dataDetail: any) =>
                                        handlePaymentUpdate(dataDetail, index)
                                    }
                                    type={type}
                                    paymentMethod={paymentMethod}
                                    vnpayTerminal={vnpayTerminal}
                                    onlyView={onlyView}
                                    handleRemoveData={() => handlePaymentRemove(index)}
                                    handleAddData={() => handlePaymentAdd()}
                                    detail={payment}
                                />
                            ))
                    }
                </div>
            </div>
            {type != 'view' &&
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                    <Button
                        onClick={() => {
                            handleSubmit()
                        }}
                        className="ml-2" color="success" type="button"
                    > Xác nhận </Button>
                </div>}
            {loading && <Loader />}
        </CardBody>
    )
}

const PaymentItem = (props: any) => {
    const { detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData, paymentMethod, vnpayTerminal, branch_id } = props
    const [fundaccount, setFundaccount] = useState<any>([]);
    const [types, setTypes] = useState("");
    const checkDataBeforeSave = () => {
        if (!data.payment_method_id || !data.fundaccount_id || !data.payment_total) {
            toast.error('Vui lòng nhập hoặc chọn đủ thông tin trước khi lưu.');
            return false;
        }
        return true;
    };
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if (name == 'name') {
            if (value?.length > 200) return
        }
        if (name.fundaccount_id == " " && name == "fundaccount_id") {
            toast.error("aaaaa")
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }
    useEffect(() => {
        loadDataFundaccount()
    }, [types]);

    useEffect(() => {
        const matchedPaymentMethod = paymentMethod?.find(
            (method: any) => data?.payment_method_id === method?.id
        );
        if (matchedPaymentMethod) {
            setTypes(matchedPaymentMethod?.fundaccount_type);
        }
    }, [data, paymentMethod]);

    const loadDataFundaccount = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 100,
        };
        const url = `${baseUrl}/fundaccount`;
        let response = await APIClient.GET(url, params)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            let ListArr: any = [];
            resData?.data?.map((e: any) => {
                if (e?.status == 1 && e?.type == types && e?.branch_id?.id == branch_id) {
                    ListArr?.push({
                        ...e,
                        value: e?.id,
                        label: e?.name,
                    });
                }
            });
            setFundaccount(ListArr)
        }
    }

    const vnpay_payment = [payment_method.vnpay_qr_id, payment_method.vnpay_spos_id].includes(Number(data?.payment_method_id))
    let payment_method_id_w = vnpay_payment ? 4 : 7
    if (onlyView) payment_method_id_w = payment_method_id_w + 1
    return (
        <Row key={detailIndex}>
            <Col md={4} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Hình thức thanh toán</Label>
                    <Select
                        placeholder={(type == 'view' && !data?.payment_method_id) ? "---" : "Chọn hình thức..."}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        name="payment_method"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'payment_method_id', value: val?.value } })}
                        value={paymentMethod?.filter(
                            (option: any) => data?.payment_method_id == option.value
                        )}
                        options={paymentMethod}

                    ></Select>
                </FormGroup>
            </Col>
            <Col md={3} xs={12} >
                <FormGroup className='nutri-form'>
                    <Label>Tài khoản quỹ</Label>
                    <Select
                        placeholder={(type == 'view' && !data?.fundaccount_id?.id) ? "---" : "Chọn..."}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'fundaccount_id', value: val?.value } })}
                        value={fundaccount?.filter(
                            (option: any) => data?.fundaccount_id?.id == option.value || data?.fundaccount_id == option.value
                        )}
                        options={fundaccount}
                    ></Select>
                </FormGroup>
            </Col>
            {vnpay_payment &&
                <Col md={3} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Chọn máy POS</Label>
                        <Select
                            placeholder={(type == 'view' && !data?.vnpay_terminal_id) ? "---" : "Chọn máy..."}
                            className="react-select mb-2"
                            classNamePrefix="react-select"
                            isDisabled={onlyView || data?.id}
                            onChange={(val: any) => handleChangeData({ target: { name: 'vnpay_terminal_id', value: val?.value } })}
                            value={vnpayTerminal?.filter(
                                (option: any) => data?.vnpay_terminal_id == option.value
                            )}
                            options={vnpayTerminal}
                        ></Select>
                    </FormGroup>
                </Col>}
            <Col md={3} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Số tiền thanh toán</Label>
                    <NumberFormat
                        disabled={data?.id}
                        onChange={(e: any) => handleChangeData({ target: { name: 'payment_total', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'payment_total'} type={'text'} className="form-control"
                        value={type === 'view' && !data?.payment_total ? '---' : data?.payment_total}
                        placeholder={(type == 'view' && !data?.payment_total) ? "---" : "Nhập số lượng..."} thousandSeparator={true}
                    />
                </FormGroup>
            </Col>
            {!onlyView &&
                <Col md={1} xs={12} className="p-0">
                    <FormGroup className='nutri-form'>
                        <Label></Label>
                        <div style={{ display: 'flex' }}>
                            {!data?.id && <Button onClick={handleRemoveData} className='nutri-square bg-none mr-2' color='success'><i className='uil-trash-alt'></i></Button>}
                            {detail?.length == detailIndex + 1 && <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button>}
                        </div>
                    </FormGroup>
                </Col>}
        </Row>
    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    &.only-view {
        border-bottom: 1px solid #e2e7f1;
    }
`

const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
`

const ValueTextTotal = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #EDA119;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-left: 20px;
`

const ValueTextTotalPayment = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #FD4858;
    margin-left: 20px;
`

const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
`

const customStyles_servicePackage = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

export default OrderAddInfo